/* eslint-disable import/prefer-default-export */
import { getEncodedParams } from 'helpers/encodeParams';

export const hyperLocalEndpoint = state => `${state.config.apiUrl}/v1/hyperlocal`;

export const hyperLocalZipDatEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/hyperlocal/zip-data?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/hyperlocal/selectors.js